import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';

import { TranslationPipe } from '../../../i18n/translation.pipe';

import { ToastService, ToastType } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [NgClass, TranslationPipe],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastContainerComponent {
  private readonly toastService = inject(ToastService);

  protected readonly toasts = this.toastService.toasts;
  protected readonly icons: Record<ToastType, string> = {
    info: 'ℹ️',
    success: '✅',
    error: '⚠️'
  };

  onDismiss(id: number): void {
    this.toastService.dismiss(id);
  }
}
